import { post } from './';
export const getMarkets = ({ filters }) => {
  return post('/api/v1/markets/list', filters);
};
